import * as React from 'react';
import { useAuthA11yMode as useSharedAuthA11yMode } from '@monorepo/shared-lib';
import { reapplyThemeRespectingA11y } from 'utils/theme-preference';

/** Shared accessibility mode state for login / signup public auth pages. */
export function useAuthA11yMode() {
  const onDisabled = React.useCallback(() => {
    reapplyThemeRespectingA11y();
  }, []);

  return useSharedAuthA11yMode(onDisabled);
}
